import type { SortOrder } from 'app/utils/sort';
import { formatSortingForAPI } from 'app/utils/sort';

export const formatPublished = (publishedFilter?: boolean[]) => {
  if (publishedFilter?.length === 1) {
    return publishedFilter[0];
  }

  return undefined;
};

export const formatSorting = (
  nameSorting: SortOrder,
  updatedAtSorting: SortOrder
) => {
  if (nameSorting && nameSorting !== 'none') {
    return {
      sortingColumn: 'name',
      sortingOrder: formatSortingForAPI(nameSorting),
    };
  }

  if (updatedAtSorting && updatedAtSorting !== 'none') {
    return {
      sortingColumn: 'updatedAt',
      sortingOrder: formatSortingForAPI(updatedAtSorting),
    };
  }

  return null;
};
